module.exports = __webpack_public_path__ + "img/shape2.af0e96a7.svg";